import api from './api';

export interface LoginParams {
  email: string;
  password: string;
}

export interface RegisterParams {
  email: string;
  password: string;
  name: string;
}

export const authService = {
  login: (params: LoginParams) => api.post('/auth/login', params),
  register: (params: RegisterParams) => api.post('/auth/register', params),
  checkCanRegister: () => api.post('/auth/check-register'),
};
